import { type CustomsDeclarationPayload } from '~/types/CustomsDeclaration';
import { type CustomsItemPayload } from '~/types/CustomsItem';
import { type OrderSelection } from '~/types/Order';
import { type TrackingAppLocation } from '~/utils/TrackingHelper/types';

import { ActionKeys } from './constants';

export const createCustomsItem = (
  orderSelection: OrderSelection,
  customsItemPayload: CustomsItemPayload,
) =>
  <const>{
    payload: {
      customsItemPayload,
      orderSelection,
    },
    type: ActionKeys.CUSTOMS_ITEM_CREATE,
  };

export const createCustomsItemSuccess = () =>
  <const>{
    type: ActionKeys.CUSTOMS_ITEM_CREATE_SUCCESS,
  };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const createCustomsItemError = (err: any) =>
  <const>{
    payload: {
      err,
    },
    type: ActionKeys.CUSTOMS_ITEM_CREATE_ERROR,
  };

export const editCustomsItem = (
  appLocation: TrackingAppLocation,
  orderSelection: OrderSelection,
  customsItemPayload: CustomsItemPayload,
  initialValues: CustomsItemPayload,
  trackingData?: {
    location?: string;
    recipientCountry?: string;
    senderCountry?: string;
    transactionId?: string;
  },
) =>
  <const>{
    payload: {
      appLocation,
      customsItemPayload,
      initialValues,
      orderSelection,
      trackingData,
    },
    type: ActionKeys.CUSTOMS_ITEM_UPDATE,
  };

export const deleteCustomsItem = (
  orderSelection: OrderSelection,
  initialValues: CustomsItemPayload[],
) =>
  <const>{
    payload: {
      initialValues,
      orderSelection,
    },
    type: ActionKeys.CUSTOMS_ITEM_DELETE,
  };

export const deleteCustomsItemSuccess = () =>
  <const>{
    type: ActionKeys.CUSTOMS_ITEM_DELETE_SUCCESS,
  };

export const deleteCustomsItemError = (error: string) =>
  <const>{
    payload: {
      error,
    },
    type: ActionKeys.CUSTOMS_ITEM_DELETE_ERROR,
  };

export const editCustomsItemSuccess = () =>
  <const>{
    type: ActionKeys.CUSTOMS_ITEM_UPDATE_SUCCESS,
  };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const editCustomsItemError = (err: any) =>
  <const>{
    payload: {
      err,
    },
    type: ActionKeys.CUSTOMS_ITEM_UPDATE_ERROR,
  };

export const editCustomsDeclaration = (
  appLocation: TrackingAppLocation,
  orderSelection: OrderSelection,
  customsDeclarationPayload: CustomsDeclarationPayload,
  initialValues: CustomsDeclarationPayload,
  trackingData?: {
    b13a_display?: boolean;
    eelpfc_display?: boolean;
    eori_display?: boolean;
    location?: string;
    recipientCountry?: string;
    senderCountry?: string;
    transactionId?: string;
  },
) =>
  <const>{
    payload: {
      appLocation,
      customsDeclarationPayload,
      initialValues,
      orderSelection,
      trackingData,
    },
    type: ActionKeys.CUSTOMS_DECLARATION_UPDATE,
  };

export const editCustomsDeclarationSuccess = () =>
  <const>{
    type: ActionKeys.CUSTOMS_DECLARATION_UPDATE_SUCCESS,
  };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const editCustomsDeclarationError = (err: any) =>
  <const>{
    payload: {
      err,
    },
    type: ActionKeys.CUSTOMS_DECLARATION_UPDATE_ERROR,
  };

export type CustomsActions =
  | ReturnType<typeof createCustomsItem>
  | ReturnType<typeof createCustomsItemError>
  | ReturnType<typeof createCustomsItemSuccess>
  | ReturnType<typeof deleteCustomsItem>
  | ReturnType<typeof deleteCustomsItemError>
  | ReturnType<typeof deleteCustomsItemSuccess>
  | ReturnType<typeof editCustomsDeclaration>
  | ReturnType<typeof editCustomsDeclarationError>
  | ReturnType<typeof editCustomsDeclarationSuccess>
  | ReturnType<typeof editCustomsItem>
  | ReturnType<typeof editCustomsItemError>
  | ReturnType<typeof editCustomsItemSuccess>;
